import React, { useContext, useEffect, useMemo } from "react";
import "./index.scss";
import FormulaGenerator from "../../../FormulaGenerator";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const RemovableProstheticsSelectTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    setStepFormula,
    dentalData
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    toggleNextBtnState(false);
  }

  const initialSelect = useMemo(() => {
    switch (stepId) {
      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop":
        return "removableProstheticsBugelTop";

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom":
        return "removableProstheticsBugelBottom";

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth":
        return "removableProstheticsBugelBoth";

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop":
        return "removableProstheticsPlasticTop";

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom":
        return "removableProstheticsPlasticBottom";

      case "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth":
        return "removableProstheticsPlasticBoth";

      default:
        return null;
    }
  }, [stepId]); // Disable next btn

  useEffect(() => {
    if (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "prostheticsTooth"))) {
      toggleNextBtnState(true);
    } else {
      toggleNextBtnState(false);
    }
  }, [dentalData, toggleNextBtnState]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "removableProstheticsSelectTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: initialSelect,
    availableSwitchers: ["top", "bottom", "base", "removableProsthetics"],
    formulaHelperText: formulaHelperText
  }));
};

export default RemovableProstheticsSelectTooth;